import * as React from "react";
import type { SVGProps } from "react";
const SvgEighteenPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.5}
      fillRule="evenodd"
      d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m-4.69-17.541q.561.78 1.61 1.188-1.16.335-1.835 1.226-.674.891-.674 2.135 0 1.207.6 2.117.599.891 1.666 1.392 1.085.483 2.51.483 1.423 0 2.51-.483 1.104-.501 1.704-1.392.6-.91.599-2.117 0-1.244-.693-2.117-.674-.891-1.835-1.244 1.01-.39 1.592-1.188.58-.817.58-1.894 0-1.002-.524-1.801-.506-.817-1.517-1.281Q16.61 9 15.187 9t-2.435.483q-.993.465-1.498 1.28a3.3 3.3 0 0 0-.506 1.802q0 1.114.562 1.894m5.937-3.435q.75.612.749 1.745 0 1.04-.787 1.69-.767.63-2.022.631-1.236 0-2.023-.631-.768-.631-.768-1.671 0-1.152.75-1.764t2.04-.613q1.312 0 2.06.613M12.92 17.04q.88-.65 2.266-.65 1.405 0 2.266.668.861.65.861 1.894 0 1.188-.842 1.913-.843.724-2.285.724t-2.304-.724q-.843-.724-.843-1.913 0-1.28.88-1.912M4 9.204v1.541h1.798V22.63H7.52V9.204zm25 7.408h-3.341V20h-1.333v-3.388H21v-1.208h3.326V12h1.333v3.404H29z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEighteenPlus;
